import { Box, VStack } from "@whoosh/design-system/src/components/primitive";

import { useFlags } from "../../../../../../../../../../../../utils/launchDarkly";
import { BillMemberEdit } from "./BillMemberEdit";
import { GuestPlayerRateEdit } from "./GuestPlayerRateEdit";
import { HostingMemberEdit } from "./HostingMemberEdit";

type Props = {
  roundId: string;
  nonPlayingHost: boolean;
  membershipTypeId: string | undefined;
};

export const GuestRoundHostRateEdit = ({
  roundId,
  nonPlayingHost,
  membershipTypeId,
}: Props) => {
  const { memberBillGuestToggle } = useFlags();

  return (
    <VStack justifyContent="space-between" flex={1}>
      <Box gap={3}>
        <HostingMemberEdit roundId={roundId} />
      </Box>

      <Box gap={3}>
        <GuestPlayerRateEdit
          membershipTypeId={membershipTypeId}
          nonPlayingHost={nonPlayingHost}
          roundId={roundId}
        />
      </Box>

      {memberBillGuestToggle ? (
        <Box gap={3}>
          <BillMemberEdit roundId={roundId} />
        </Box>
      ) : (
        <Box />
      )}
    </VStack>
  );
};
